import clsx from "clsx"
import { DeleteIcon } from "../../icons/deleteIcon"

export const Chip = ({mode, content, handleAction, selected, className}) => {

    if(mode === 'select'){
        return(
            <div onClick={handleAction} className={clsx('cursor-pointer py-2 px-5 text-xs rounded-full w-fit',selected && 'bg-black text-white', className)}>{content}</div>
        )
    }else{
        return(
            <div className={clsx("flex gap-1 items-center", className)}>
                <p className="text-xs">{content}</p>
               <DeleteIcon className={'cursor-pointer'} onClick={handleAction}/>
            </div>
        )
    }
}